var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconoir:leaderboard-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 21H9M15 21V12.6C15 12.4409 14.9368 12.2883 14.8243 12.1758C14.7117 12.0632 14.5591 12 14.4 12H9.6C9.44087 12 9.28826 12.0632 9.17574 12.1758C9.06321 12.2883 9 12.4409 9 12.6V21M15 21H20.4C20.5591 21 20.7117 20.9368 20.8243 20.8243C20.9368 20.7118 21 20.5591 21 20.4V18.1C21 17.9409 20.9368 17.7883 20.8243 17.6758C20.7117 17.5632 20.5591 17.5 20.4 17.5H15.6C15.4409 17.5 15.2883 17.5632 15.1757 17.6758C15.0632 17.7883 15 17.9409 15 18.1V21ZM9 21V16.1C9 15.9409 8.93679 15.7883 8.82426 15.6758C8.71174 15.5632 8.55913 15.5 8.4 15.5H3.6C3.44087 15.5 3.28826 15.5632 3.17574 15.6758C3.06321 15.7883 3 15.9409 3 16.1V20.4C3 20.5591 3.06321 20.7118 3.17574 20.8243C3.28826 20.9368 3.44087 21 3.6 21H9ZM10.806 5.11302L11.715 3.18602C11.7395 3.13093 11.7795 3.08413 11.8301 3.05129C11.8807 3.01845 11.9397 3.00098 12 3.00098C12.0603 3.00098 12.1193 3.01845 12.1699 3.05129C12.2205 3.08413 12.2605 3.13093 12.285 3.18602L13.195 5.11302L15.227 5.42402C15.488 5.46402 15.592 5.80002 15.403 5.99202L13.933 7.49202L14.28 9.61002C14.324 9.88202 14.052 10.09 13.818 9.96102L12 8.96102L10.182 9.96102C9.949 10.089 9.676 9.88202 9.72 9.61002L10.067 7.49202L8.597 5.99202C8.407 5.80002 8.512 5.46402 8.772 5.42402L10.806 5.11302Z",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLead);
export default __webpack_public_path__ + "static/media/lead.c3463c82332390c5a14d822dbcec7d34.svg";
export { ForwardRef as ReactComponent };